import { PinkButton, WhiteButton } from 'core/buttons/buttons';

import PropTypes from 'prop-types';
import RightIcon from 'core/icons/right-icon';
import { useTranslations } from 'next-intl';

/**
 * # BannerButton
 *
 * @component
 * @returns {JSX.Element} Banner But<<<<ton that change the colorSchema due a condition.
 * @example
 *   <BannerButton colorSchema={condition ? 'white':'pink'} buttonProps={{ onClick: callback }} />
 */
const BannerButton = ({ buttonProps = {}, colorSchema = 'white' }) => {
    const t = useTranslations('swiper');
    const Button = colorSchema === 'white' ? WhiteButton : PinkButton;

    return (
        <Button
            label={`${t('button.before-bar')} | ${t('button.after-bar')}`}
            endIcon={<RightIcon width={9} height={9} />}
            {...buttonProps}
        />
    );
};

BannerButton.propTypes = {
    /**
     * Indicate which default button will be rendered, toggling between white and pink colorSchema.
     */
    colorSchema: PropTypes.oneOf(['white', 'pink']),
    /**
     * Pass through any button property to the base button of the core.
     */
    buttonProps: PropTypes.object
};

export default BannerButton;
